export default [
  { text: '9908001 - Behavioral Health', value: '9908001' },
  { text: '9908003 - Burn Center', value: '9908003' },
  { text: '9908005 - Critical Access Hospital', value: '9908005' },
  { text: '9908007 - Hospital (General)', value: '9908007' },
  { text: '9908009 - Neonatal Center', value: '9908009' },
  { text: '9908011 - Pediatric Center', value: '9908011' },
  { text: '9908019 - Rehab Center', value: '9908019' },
  { text: '9908021 - Trauma Center Level 1', value: '9908021' },
  { text: '9908023 - Trauma Center Level 2', value: '9908023' },
  { text: '9908025 - Trauma Center Level 3', value: '9908025' },
  { text: '9908027 - Trauma Center Level 4', value: '9908027' },
  { text: '9908029 - Trauma Center Level 5', value: '9908029' },
  { text: '9908031 - Cardiac-STEMI/PCI Capable', value: '9908031' },
  { text: '9908033 - Cardiac-STEMI/PCI Capable (24/7)', value: '9908033' },
  { text: '9908035 - Cardiac-STEMI/Non-PCI Capable', value: '9908035' },
  { text: '9908037 - Stroke-Acute Stroke Ready Hospital (ASRH)', value: '9908037' },
  { text: '9908039 - Stroke-Primary Stroke Center (PSC)', value: '9908039' },
  { text: '9908041 - Stroke-Thrombectomy-Capable Stroke Center (TSC)', value: '9908041' },
  { text: '9908043 - Stroke-Comprehensive Stroke Center (CSC)', value: '9908043' },
  { text: '9908045 - Cancer Center', value: '9908045' },
  { text: '9908047 - Labor and Delivery', value: '9908047' },
];
